module.exports = __webpack_public_path__ + "img/14.1dd77cd3.jpg";